import { ComponentType } from 'react';

import { useDataSyncing } from '@dreryk/command-query-react-common';
import {
   ActionBar,
   ActionBarElementType,
   DataSyncWaitingEventInterceptor,
   ValidateFormEventInterceptor,
} from '@dreryk/react-components';

import visitSettlement from '../../../../visitSettlement';
import { VisitFormController, VisitFormDraftSubmitHandler } from '../../visitForm.types';

import { ConfirmVisitLaterActionProps } from './ConfirmVisitLaterAction';

export const withConfirmVisitLaterActionInterceptors = (Component: ComponentType<ConfirmVisitLaterActionProps>) => (
   props: Pick<VisitFormController, 'control' | 'trigger'> & {
      readonly handleSubmitDraft: VisitFormDraftSubmitHandler;
      readonly visitId: number;
      readonly appointmentId: number;
   }
): JSX.Element => {
   return (
      <ActionBar.Portal elementType={ActionBarElementType.PRIMARY}>
         <DataSyncWaitingEventInterceptor waitUntil={useDataSyncing()}>
            {(waiting) => (
               <ValidateFormEventInterceptor trigger={props.trigger}>
                  <visitSettlement.MedicalServicesUpdateEventInterceptor
                     appointmentId={props.appointmentId}
                     control={props.control}
                  >
                     <Component handleSubmitDraft={props.handleSubmitDraft} waiting={waiting} visitId={props.visitId} />
                  </visitSettlement.MedicalServicesUpdateEventInterceptor>
               </ValidateFormEventInterceptor>
            )}
         </DataSyncWaitingEventInterceptor>
      </ActionBar.Portal>
   );
};
